/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MPIBaseService } from '../mpi-base-service';
import { MPIApiConfiguration } from '../mpi-api-configuration';
import { MPIStrictHttpResponse } from '../mpi-strict-http-response';

import { bookBookRegistrationIdDelete } from '../fn/book/book-book-registration-id-delete';
import { BookBookRegistrationIdDelete$Params } from '../fn/book/book-book-registration-id-delete';
import { bookBookRegistrationIdGet } from '../fn/book/book-book-registration-id-get';
import { BookBookRegistrationIdGet$Params } from '../fn/book/book-book-registration-id-get';
import { bookBookRegistrationIdPinPost } from '../fn/book/book-book-registration-id-pin-post';
import { BookBookRegistrationIdPinPost$Params } from '../fn/book/book-book-registration-id-pin-post';
import { bookBookRegistrationIdUsernameGet } from '../fn/book/book-book-registration-id-username-get';
import { BookBookRegistrationIdUsernameGet$Params } from '../fn/book/book-book-registration-id-username-get';
import { bookCompleteBookRegistrationIdPost } from '../fn/book/book-complete-book-registration-id-post';
import { BookCompleteBookRegistrationIdPost$Params } from '../fn/book/book-complete-book-registration-id-post';
import { bookPinPinGet } from '../fn/book/book-pin-pin-get';
import { BookPinPinGet$Params } from '../fn/book/book-pin-pin-get';
import { bookPost } from '../fn/book/book-post';
import { BookPost$Params } from '../fn/book/book-post';
import { bookRegisterBookRegistrationIdPost } from '../fn/book/book-register-book-registration-id-post';
import { BookRegisterBookRegistrationIdPost$Params } from '../fn/book/book-register-book-registration-id-post';
import { BookRegistrationDto } from '../models/book-registration-dto';
import { BookRegistrationResultModel } from '../models/book-registration-result-model';
import { RegistrationPinResponseDto } from '../models/registration-pin-response-dto';

@Injectable({ providedIn: 'root' })
export class MPIBookService extends MPIBaseService {
  constructor(config: MPIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `bookPost()` */
  static readonly BookPostPath = '/Book';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  bookPost$Response(params?: BookPost$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<BookRegistrationResultModel>> {
    return bookPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  bookPost(params?: BookPost$Params, context?: HttpContext): Observable<BookRegistrationResultModel> {
    return this.bookPost$Response(params, context).pipe(
      map((r: MPIStrictHttpResponse<BookRegistrationResultModel>): BookRegistrationResultModel => r.body)
    );
  }

  /** Path part for operation `bookBookRegistrationIdGet()` */
  static readonly BookBookRegistrationIdGetPath = '/Book/{bookRegistrationId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookBookRegistrationIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookBookRegistrationIdGet$Response(params: BookBookRegistrationIdGet$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<BookRegistrationDto>> {
    return bookBookRegistrationIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookBookRegistrationIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookBookRegistrationIdGet(params: BookBookRegistrationIdGet$Params, context?: HttpContext): Observable<BookRegistrationDto> {
    return this.bookBookRegistrationIdGet$Response(params, context).pipe(
      map((r: MPIStrictHttpResponse<BookRegistrationDto>): BookRegistrationDto => r.body)
    );
  }

  /** Path part for operation `bookBookRegistrationIdDelete()` */
  static readonly BookBookRegistrationIdDeletePath = '/Book/{bookRegistrationId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookBookRegistrationIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookBookRegistrationIdDelete$Response(params: BookBookRegistrationIdDelete$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<void>> {
    return bookBookRegistrationIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookBookRegistrationIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookBookRegistrationIdDelete(params: BookBookRegistrationIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.bookBookRegistrationIdDelete$Response(params, context).pipe(
      map((r: MPIStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `bookBookRegistrationIdUsernameGet()` */
  static readonly BookBookRegistrationIdUsernameGetPath = '/Book/{bookRegistrationId}/{username}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookBookRegistrationIdUsernameGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookBookRegistrationIdUsernameGet$Response(params: BookBookRegistrationIdUsernameGet$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<BookRegistrationDto>> {
    return bookBookRegistrationIdUsernameGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookBookRegistrationIdUsernameGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookBookRegistrationIdUsernameGet(params: BookBookRegistrationIdUsernameGet$Params, context?: HttpContext): Observable<BookRegistrationDto> {
    return this.bookBookRegistrationIdUsernameGet$Response(params, context).pipe(
      map((r: MPIStrictHttpResponse<BookRegistrationDto>): BookRegistrationDto => r.body)
    );
  }

  /** Path part for operation `bookPinPinGet()` */
  static readonly BookPinPinGetPath = '/Book/Pin/{pin}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookPinPinGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookPinPinGet$Response(params: BookPinPinGet$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<BookRegistrationDto>> {
    return bookPinPinGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookPinPinGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookPinPinGet(params: BookPinPinGet$Params, context?: HttpContext): Observable<BookRegistrationDto> {
    return this.bookPinPinGet$Response(params, context).pipe(
      map((r: MPIStrictHttpResponse<BookRegistrationDto>): BookRegistrationDto => r.body)
    );
  }

  /** Path part for operation `bookBookRegistrationIdPinPost()` */
  static readonly BookBookRegistrationIdPinPostPath = '/Book/{bookRegistrationId}/Pin';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookBookRegistrationIdPinPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookBookRegistrationIdPinPost$Response(params: BookBookRegistrationIdPinPost$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<RegistrationPinResponseDto>> {
    return bookBookRegistrationIdPinPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookBookRegistrationIdPinPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookBookRegistrationIdPinPost(params: BookBookRegistrationIdPinPost$Params, context?: HttpContext): Observable<RegistrationPinResponseDto> {
    return this.bookBookRegistrationIdPinPost$Response(params, context).pipe(
      map((r: MPIStrictHttpResponse<RegistrationPinResponseDto>): RegistrationPinResponseDto => r.body)
    );
  }

  /** Path part for operation `bookRegisterBookRegistrationIdPost()` */
  static readonly BookRegisterBookRegistrationIdPostPath = '/Book/Register/{bookRegistrationId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookRegisterBookRegistrationIdPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  bookRegisterBookRegistrationIdPost$Response(params: BookRegisterBookRegistrationIdPost$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<void>> {
    return bookRegisterBookRegistrationIdPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookRegisterBookRegistrationIdPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  bookRegisterBookRegistrationIdPost(params: BookRegisterBookRegistrationIdPost$Params, context?: HttpContext): Observable<void> {
    return this.bookRegisterBookRegistrationIdPost$Response(params, context).pipe(
      map((r: MPIStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `bookCompleteBookRegistrationIdPost()` */
  static readonly BookCompleteBookRegistrationIdPostPath = '/Book/Complete/{bookRegistrationId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookCompleteBookRegistrationIdPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  bookCompleteBookRegistrationIdPost$Response(params: BookCompleteBookRegistrationIdPost$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<void>> {
    return bookCompleteBookRegistrationIdPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookCompleteBookRegistrationIdPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  bookCompleteBookRegistrationIdPost(params: BookCompleteBookRegistrationIdPost$Params, context?: HttpContext): Observable<void> {
    return this.bookCompleteBookRegistrationIdPost$Response(params, context).pipe(
      map((r: MPIStrictHttpResponse<void>): void => r.body)
    );
  }

}
